import camelCaseKeys from "camelcase-keys";
import { groupBy, reduce } from "lodash";
import { postJsonRequest, getJsonRequest } from "Helpers/ApiRequest";

const getAuth = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("sogui_token"))
    ?.split("=")[1];

const authorizedGet = (params) =>
  getJsonRequest({
    ...params,
    headers: { Authorization: `Bearer ${getAuth()}` },
  });
const authorizedPost = (params) =>
  postJsonRequest({
    ...params,
    headers: { Authorization: `Bearer ${getAuth()}` },
  });

export const mapCustomerTab = (customerTab) => {
  const getKey = (orderItem) =>
    [
      orderItem.itemUuid,
      ...orderItem.orderItemMods.map((oim) => oim.itemModUuid),
    ].join(",");
  const allOrderItems = customerTab.orders.flatMap((order) => order.orderItems);
  const orderItemListPerItemUuid = groupBy(allOrderItems, getKey);

  const mergeOrderItems = (orderItem, nextOrderItem) => {
    return {
      ...orderItem,
      multiplier: +orderItem.multiplier + +nextOrderItem.multiplier,
      totalSalesPriceTaxInclusive:
        +orderItem.totalSalesPriceTaxInclusive +
        +nextOrderItem.totalSalesPriceTaxInclusive,
    };
  };

  const orderItems = reduce(
    orderItemListPerItemUuid,
    (orderItemList, orderItems) => [
      ...orderItemList,
      orderItems.reduce(mergeOrderItems),
    ],
    []
  );

  const isCredit = (transaction) => transaction.transactionType == "CREDIT";
  const isDebit = (transaction) => !isCredit(transaction);
  const sumTransactions = (total, transaction) =>
    total + +transaction.taxInclusive;
  const totalCredits = customerTab.transactions
    .filter(isCredit)
    .reduce(sumTransactions, 0);

  const totalDebits = customerTab.transactions
    .filter(isDebit)
    .reduce(sumTransactions, 0);
  const totalPayments = totalCredits - totalDebits;
  const itemTotal = orderItems.reduce(
    (total, orderItem) => total + +orderItem.totalSalesPriceTaxInclusive,
    0
  );

  return {
    ...customerTab,
    itemTotal,
    balance: +customerTab.balance,
    totalPayments,
    totalDebits,
    totalCredits,
    orderItems,
  };
};

export const fetchCustomerTab = async (customerTabUuid) => {
  const { body } = await authorizedGet({
    url: `/v1/customer_tabs/${customerTabUuid}`,
  });
  return mapCustomerTab(camelCaseKeys(body.customer_tab, { deep: true }));
};

export const createCheckoutSession = async ({
  customerTabUuid,
  taxInclusive,
}) => {
  const { body } = await authorizedPost({
    url: `/v1/customer_tabs/${customerTabUuid}/checkout_sessions`,
    body: {
      transaction: { taxInclusive },
    },
  });

  return body.checkout_url;
};
